import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

interface Payload {
  templateName: string;
}

/**
 * Track A, Phase 6 — "Restore Default" (12 Aug call, 35:54–36:18). Read-only:
 * fetches the seed markup for one template name. The caller loads the result
 * into the editor; nothing is persisted until the existing Update action runs.
 */
export const getDefaultReportTemplateApi = createAsyncThunk(
  'Get Default Report Template',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
      };
      const res = await fetch(
        `${REPORTS.GET_DEFAULT_REPORT_TEMPLATE_URL}?templateName=${encodeURIComponent(payload.templateName)}`,
        requestOptions
      );

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.msg || 'Unable to fetch default template');
      }

      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
